import React from 'react';
import ProductsHero from '../components/ProductsHero/ProductsHero';
import ProductCredentialVaultContent from '../components/ProductCredentialVaultContent/ProductCredentialVaultContent';
import './Products.css';

const ProductsCredentialVault = () => {
  return (
    <div className="products-page">
      <ProductsHero title="Credentials Vault" bannerSection="Products > Credentials Vault">
        <p className="text-muted">
         Are you sharing passwords through Emails, WhatsApp or Excel files? Are you having challenges
         in distributing corporate level credentials among team members? Are you worried about your
         passwords being leaked to the outside world?
        </p>
        <p className="text-muted">
        flowdo Credentials Vault is a highly secured credential storage tool, that will help you store corporate level and personal credentials in one place and have access from any part of the world. 2-level authentication and 2-level encryption ensures that your credentials are under your own control. Our encryption ensures that even flowdo team cannot access the stored credentials.
        </p>
      </ProductsHero>
      <ProductCredentialVaultContent />
    </div>
  );
};

export default ProductsCredentialVault;
